import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useAnalytics from 'services/hooks/analytics';
import { events } from 'services/analytics';
import { Header, ComingSoonDialog, StatusLabel } from './components';
import { PlaybackStatsContainer, InfoContainer, StyledButton } from './styled';

const PlaybackStats = () => {
  const { t } = useTranslation();
  const { track } = useAnalytics();

  const [isComingSoonDialogOpen, setIsComingSoonDialogOpen] = useState(false);

  const handleComingSoonDialogOpen = useCallback(() => {
    track(events.displayReleasePlaybackStats());
    setIsComingSoonDialogOpen(true);
  }, [track]);

  const handleComingSoonDialogClose = () => {
    setIsComingSoonDialogOpen(false);
  };

  return (
    <>
      <PlaybackStatsContainer>
        <Header />
        <InfoContainer>
          <StatusLabel />
          <StyledButton variant="outlined" onClick={handleComingSoonDialogOpen}>
            {t('distribution:playbackStats:viewStats')}
          </StyledButton>
        </InfoContainer>
      </PlaybackStatsContainer>

      <ComingSoonDialog
        isOpen={isComingSoonDialogOpen}
        onClose={handleComingSoonDialogClose}
      />
    </>
  );
};

export default PlaybackStats;
